export const MESSAGES = {
  M0001: 'Please fill out this field',
  M0086: 'Please enter a unique subfolder name',
  M0094: 'You can not download an empty folder',
  М0112: 'Please rate the lawyer for at least one question',
  M0118: 'Please enter the value less than the amount of the invoice and not equal to 0',
  M0119: 'Please enter the value that is less than the amount of the invoice and greater than 0',
}
